import { OrderList } from '@ui/features/Trade/components/OrderList/OrderList';
import { useTradeOrders } from '@ui/hooks/trade/useTradeOrders/useTradeOrders';
import { Text } from '@ui/lib/park/ui/text';
import { useTranslation } from 'next-i18next';
import { Center } from 'styled-system/jsx';
import type { Address } from 'viem';

export const Orders = ({
  hideFilters,
  userAddress,
}: {
  hideFilters?: boolean;
  userAddress?: Address;
}) => {
  const { data: orders } = useTradeOrders(userAddress);

  return (
    <OrderList
      orders={orders || []}
      emptyView={<Empty />}
      showCurrentPairToggle={!hideFilters}
    />
  );
};

const Empty = () => {
  const { t } = useTranslation();

  return (
    <Center py="6">
      <Text textStyle="v2.ui" color="v2.text.subtle">
        {t("common.You currently don't have any open orders.")}
      </Text>
    </Center>
  );
};
